export type ChoiceOptionType = {
  value: string;
  label: string;
  checked?: boolean;
}

export const BACKEND_URL = process.env.REACT_APP_AXIOS_URL;
export const BACKEND_WS_URL = process.env.REACT_APP_WS_URL;